import moment from 'moment-cn'
const buildCode = function (code) {
  let x = Math.floor(code / 26)
  let y = code % 26
  if (y === 0) {
    y = 26
    x--
  }
  return (x > 0 ? buildCode(x) : '') + String.fromCharCode(96 + y)
}
export default {
  'toChar': function (num) {
    return String.fromCharCode(num)
  },
  'upper': function (s) {
    return s.toUpperCase()
  },
  'lower': function (s) {
    return s.toLowerCase()
  },
  'format': function (date, fmt) {
    return moment(date).format(fmt || 'YYYY-MM-DD HH:mm:ss')
  },
  buildCode: buildCode
}



// WEBPACK FOOTER //
// ./src/filters.js